import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';
import FormDataContext from 'integrations/contexts/FormDataContext';

import { Input } from 'components/bootstrap';

import { AdvancedOptionsContext } from './context/AdvancedOptions';
import type { HandleFieldUpdateType, AdvancedOptionsContextType } from './types';

interface Props {
  onChange: HandleFieldUpdateType;
}

const FormAdvancedOptions = ({ onChange }: Props) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } =
    useContext<AdvancedOptionsContextType>(AdvancedOptionsContext);

  const { azureThrottleEnabled, azureStoreFullMessage } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox id="azureThrottleEnabled" defaultChecked={azureThrottleEnabled?.value} onChange={onChange} />
      <Input
        id="azureStoreFullMessage"
        type="checkbox"
        value="enable-storeFullMessage"
        defaultChecked={azureStoreFullMessage?.value}
        onChange={onChange}
        label="Store Full Message"
        help="Store the full original Azure log record message as full_message?"
      />
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
